/** @format */

import React, {useContext, useState} from 'react';
import {IconButton, Input} from '@sttark/design-system';
import {capitalize} from 'frontier/ds/quoter/functions/format';
import {QuoteContext} from 'frontier-quoter';
import {Button} from '@sttark/design-system';

import './design_total_input.sass';

export default function DesignTotalInput(props) {
    const ctx = useContext(QuoteContext);

    const count = ctx.order.is_front_back
        ? Math.max(1, props.designQty)
        : Math.max(1, Math.ceil(props.designQty / 2));

    const [totalQty, setTotalQty] = useState(Math.floor(props.totalQty / 2) / count);

    if (ctx.order.is_duplex || ctx.order.is_front_back) {
        let groups = [...Array(count).keys()];
        return (
            <div>
                {groups.map((n, index) => {
                    return (
                        <div key={index} className="duplex-group">
                            <div className="duplex-group-inner">
                                <div className="duplex-group-item">
                                    <h4>
                                        {capitalize(ctx.singularProduct)} {index + 1}
                                    </h4>
                                </div>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <Input
                                        label={`Total ${capitalize(ctx.singularProduct)} Quantity`}
                                        size="16"
                                        value={totalQty}
                                        onChange={value => {
                                            // front back does not need to double the quantity
                                            if (ctx.order.is_front_back) {
                                                setTotalQty(value);
                                                props.onChangeQuantity(value * count);
                                                return;
                                            }
                                            setTotalQty(value);
                                            props.onChangeQuantity(value * 2 * count);
                                        }}
                                    />
                                    <div style={{marginLeft: '10px'}}>
                                        <IconButton
                                            tabIndex="-1"
                                            secondary
                                            icon="trash"
                                            onClick={() => {
                                                const maxCount = ctx.order.is_front_back ? 1 : 2;
                                                let newCount =
                                                    parseInt(Math.max(maxCount, props.designQty)) -
                                                    maxCount;
                                                newCount = Math.max(maxCount, newCount);
                                                props.onChangeDesignQuantity(newCount);
                                                const newQuantity = totalQty * newCount;
                                                props.onChangeQuantity(newQuantity);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
                <Button
                    secondary
                    label={`Add Another ${capitalize(ctx.singularProduct)} Design`}
                    onClick={() => {
                        // if it is a front back we do not to double the quantity
                        const maxCount = ctx.order.is_front_back ? 1 : 2;

                        const newCount = parseInt(Math.max(maxCount, props.designQty)) + maxCount;
                        props.onChangeDesignQuantity(newCount);
                        const newQuantity = totalQty * newCount;
                        props.onChangeQuantity(newQuantity);
                    }}></Button>
            </div>
        );
    }

    return (
        <>
            <Input
                label="Number of Designs"
                size="16"
                value={props.designQty}
                onChange={props.onChangeDesignQuantity}
            />
            <Input
                label={`Total ${capitalize(ctx.singularProduct)} Quantity`}
                size="16"
                value={props.totalQty}
                onChange={props.onChangeQuantity}
            />
        </>
    );
}
